export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult_01.f459da38.jpg";